var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-warning",attrs:{"role":"alert"}},[_vm._v(" Insta Pay Link page "+_vm._s(_vm.slug)+" cannot be found ")])}
var staticRenderFns = []

export { render, staticRenderFns }